import "./BlogMarketInsights.module.css";
import Header from "@/reusable_sections/Header";
import BlogListing from "./sections/BlogListing";
import NewsletterSignup from "./sections/NewsletterSignup";
import Footer from "@/reusable_sections/Footer";
export default function BlogMarketInsightsPage() {
  return <div>
      <Header />
      <BlogListing />
      <NewsletterSignup />
      <Footer />
    </div>;
}